module.exports = __webpack_public_path__ + "static/img/Parametric Studies 4 - RAAN Phasing.22099d6.png";